export default "__VITE_ASSET__6a72149c__"